/* Goldtop sizing guide (sections/gt-sizing-guide.liquid). Oct 2026.
   The size calculator (assets/sh-size-finder.js) was written for jacket
   pages: its last step ("Shop my size", "Save my size", "No thanks, shop
   my size") saves the size and closes, which on a jacket page leaves the
   shopper on the jacket with that size picked. On this page there is no
   jacket, so closing would strand them here. This sends them on to the
   men's jackets in stock in the size the calculator chose instead.
   Closing with the cross or Escape does not redirect. */
(function () {
  var go = false;
  document.addEventListener('click', function (e) {
    if (e.target.closest('#shsf-root [data-shsf-close]')) { go = false; return; }
    if (e.target.closest('#shsf-root .shsf-skip, #shsf-root .shsf-savecta')) go = true;
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') go = false; }, true);
  new MutationObserver(function () {
    if (!go || document.getElementById('shsf-root')) return;
    go = false;
    var size = '';
    try { size = window.localStorage.getItem('shsf_size') || ''; } catch (e) {}
    var url = '/collections/jackets';
    if (size) url += '?filter.v.availability=1&filter.v.option.size=' + encodeURIComponent(size + '"');
    window.location.href = url;
  }).observe(document.body, { childList: true });
})();
